<script>
  export let url;
  export let text = "";

  export let haspopup = false;
  export let expanded = false;

  let clazz;
  export { clazz as class };
  export let textClasses;

  let innerWidth;

  function makeCorrespondingHeaderFocusable() {
    const lgBreakpoint = 1366;
    if (window.innerWidth >= lgBreakpoint && url.startsWith("#")) {
      const headingId = url.slice(1);
      const heading = document.getElementById(headingId);
      heading.setAttribute("tabIndex", "-1");
    }
  }
</script>

<svelte:window bind:innerWidth />

<a
  class="flex flex-nowrap text-size-base font-bold tracking-wide no-underline text-black leading-6 px-24 md:px-32 py-16 md:py-24 min-w-fit hover:text-secondary hover:bg-indigo-50 hover:underline hover:cursor-pointer active:text-black active:bg-white active:underline generic-focus focus:ring-inset ring-focus:text-black focus:rounded-0 focus:underline max-w-max whitespace-nowrap{clazz}"
  href={url}
  on:click={makeCorrespondingHeaderFocusable}
  aria-haspopup={haspopup}
  aria-expanded={haspopup ? expanded : null}
>
  <div class={textClasses}>
    {#if text}
      {text}
    {:else}
      <slot />
    {/if}
  </div>
</a>
